<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑供应商' : '新增供应商'"
      width="960px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <div class="mu-ban-category">
            <div style="width: 120px; text-align: right">
              <span class="m-r-5 c-black">关联类目</span>
            </div>
            <b-goods-texture
              :data.sync="categoryTextureData"
              :isLoadTexture="false"
              width="800px"
            />
          </div>
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :rules="formRules"
            :data.sync="selfData"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      categoryTextureData: {
        category_list: []
      },
      selfData: {
        id: '',
        category_list: [],
        category_ids: [],
        category_str: '',
        supplier_name: '',
        process_type_list: [],
        process_type_ids: [],
        linkman: '',
        linkman_phone: '',
        remark: '',
        address_ids: [],
        address_str: '',
        address_detail: '',
        state: '激活'
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '供应商名称',
          field: 'supplier_name'
        },
        {
          type: 'select',
          title: '经营商品',
          field: 'mu_ban_id_list',
          multiple: true,
          options: []
        },
        {
          type: 'select',
          title: '加工类型',
          field: 'process_type_ids',
          multiple: true,
          options: []
        },
        {
          type: 'text',
          title: '微信号',
          field: 'wei_xin_code'
        },
        {
          type: 'text',
          title: '联系人',
          field: 'linkman'
        },
        {
          type: 'number',
          title: '联系人电话',
          field: 'linkman_phone'
        },
        {
          type: 'address',
          title: '联系地址',
          field: 'address_ids'
        },
        {
          type: 'text',
          title: '详细地址',
          field: 'address_detail'
        },
        {
          type: 'text',
          title: '备注',
          field: 'remark'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'state',
          activeValue: '激活',
          inactiveValue: '禁用'
        }
      ],
      formRules: {}
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getMuBanListData()
    this.getProcessTypeListData()
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.loaded = true
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/supplier/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          // 加工类型数据转换：对象数组转ID数组用于下拉回显
          if (result.process_type_list && result.process_type_list.length) {
            result.process_type_ids = result.process_type_list.map((item) => item.id)
          } else {
            result.process_type_ids = []
            result.process_type_list = []
          }
          this.selfData = result
          this.categoryTextureData.category_list = this.$util.deepCopy(result.category_list)
        }
      })
      this.loaded = true
    },
    // 获取加工类型列表数据（类目类型为"加工"）
    getProcessTypeListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          bao_han: ['加工'],
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.formColumn.forEach((item) => {
              if (item.field === 'process_type_ids') {
                item.options = res.data.page.list.map((itemNd) => {
                  return {
                    key: itemNd.mu_ban_ming_cheng,
                    val: itemNd.id
                  }
                })
              }
            })
          }
        })
        .catch(() => {})
    },
    // 获取模板列表数据
    getMuBanListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.formColumn.forEach((item) => {
              if (item.field === 'mu_ban_id_list') {
                item.options = res.data.page.list.map((itemNd) => {
                  let result = {
                    key: itemNd.mu_ban_ming_cheng,
                    val: itemNd.id
                  }
                  return result
                })
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let category_list = this.$util.deepCopy(this.categoryTextureData.category_list)
      this.selfData.category_ids = category_list.map((item) => item.id)
      // 加工类型数据转换：ID数组转对象数组用于提交
      this.selfData.process_type_list = this.selfData.process_type_ids
        ? this.selfData.process_type_ids.map((id) => {
            let option = this.formColumn
              .find((item) => item.field === 'process_type_ids')
              .options.find((opt) => opt.val === id)
            return {
              id: id,
              name: option ? option.key : ''
            }
          })
        : []
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          let url = ''
          if (this.selfData.id) {
            url = '/admin/supplier/updateVue'
          } else {
            url = '/admin/supplier/saveVue'
          }
          this.$api({
            method: 'post',
            url,
            data: this.selfData
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .mu-ban-category {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
